<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { APP_URL } from '@/lib/site';
import logo from '@/assets/img/logo-dark.svg';

const scrolled = ref(false);
const onScroll = () => (scrolled.value = window.scrollY > 8);

onMounted(() => {
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
});
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));
</script>

<template>
  <header class="header" :class="{ scrolled }">
    <div class="wrap inner">
      <RouterLink to="/" class="brand" aria-label="Minni Map home">
        <img :src="logo" alt="minni map" width="108" />
      </RouterLink>
      <nav class="nav" aria-label="Main">
        <a href="/#demo" class="demo-link">Demo</a>
        <a href="/#features">Features</a>
        <a href="/#whats-new">What's new</a>
        <a href="/#faq">Questions</a>
      </nav>
      <a :href="APP_URL" target="_blank" rel="noopener" class="cta">Open Minni Map</a>
    </div>
  </header>
</template>

<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(246, 246, 250, 0.82);
  backdrop-filter: saturate(160%) blur(12px);
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;

  &.scrolled {
    border-bottom-color: var(--line);
  }
}

.inner {
  display: flex;
  align-items: center;
  gap: 32px;
  height: 64px;
}

.brand img {
  display: block;
}

.nav {
  display: flex;
  gap: 26px;
  margin-left: auto;

  a {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-2);

    &:hover {
      color: var(--text);
      text-decoration: none;
    }
  }
}

.cta {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;
  border-radius: 9px;
  background: var(--ink);
  color: #fff;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    text-decoration: none;
    background: var(--ink-3);
  }
}

@media (max-width: 1023px) {
  .demo-link {
    display: none;
  }
}

@media (max-width: 640px) {
  .nav {
    display: none;
  }

  .cta {
    margin-left: auto;
  }
}
</style>
